
  $(document).ready(function(){
    $(".ProductRegionalzipCode .ZipPostalCode").click(function(){
         var check_zipcode = localStorage.getItem("zipcode");
         if(!check_zipcode){
          getLocation();
         }
    });

       $(".redioButton").click(function(){
     var check_store = $(this).attr("data-value");
      var mainClass = $(this).attr("data-class");
      console.log(mainClass);
    // if(check_store == "US"){
    //   $("."+mainClass+" .usaCountry:radio").trigger("click");
    //     $("."+mainClass+" .regionalInputLbabel").text("Enter Zip code"); 
    //   $("."+mainClass+" .regional_input").attr("placeholder","Zip Code*");
    // }else{
    //    $("."+mainClass+" .caCountry:radio").trigger("click");
    //    $("."+mainClass+" .regionalInputLbabel").text("Enter Postal code"); 
    //   $("."+mainClass+" .regional_input").attr("placeholder","Postal Code*");
    // }
      
      // alert(check_store,check_class);
    });
  // $(".regionalMainPopup,.back-drop").addClass("hide");
        var timeOut = 2000;
    if(main_page_url.indexOf("/pages/cart")!=-1){
      timeOut = 6000;
    }
    let isZipPresent = false;
     if(document.URL.indexOf("z=")>=0){
      isZipPresent = true;
    }
setTimeout(function(){
 var zipcode = localStorage.getItem("zipcode");
 if(isZipPresent){return false;}
  var zipcodePopup = localStorage.getItem("zipcodePopup");
  if(zipcode == "" || zipcode === null ){
    // if(zipcodePopup == "" || zipcodePopup === null ){
    //       
    // }
    //$(".regionalMainPopup,.back-drop").removeClass("hide");  
    $(".regionalMainPopup .regionalSubmitBtn  ").attr("data-class","regionalMainPopup");
    $(".regionalMainPopup .redioButton  ").attr("data-class","regionalMainPopup");
    //getLocation(); 
   
  }else{
    console.log("zipcode",zipcode);
    $(".regionalMainPopup,.back-drop").addClass("hide"); 
      $(".RegionalHeaderCode .addReplaceZipcode").text(zipcode);   
    $(".collectionRegionalzipCode .addReplaceZipcode").text(zipcode);
     $(".ProductRegionalzipCode .addReplaceZipcode").text(zipcode);
    }
  console.log("timeout is  ", timeOut,main_page_url.indexOf("/pages/cart"));
},timeOut);
   var allowGeoRecall = true;
       var countLocationAttempts = 0; 
  function getLocation() {   
        console.log('getLocation was called') 
        if(navigator.geolocation) {
            // navigator.geolocation.getCurrentPosition(showPosition, 
            //positionError);
        } else {
            hideLoadingDiv()
            console.log('Geolocation is not supported by this device')
        }
    }

    function positionError() {    
        console.log('Geolocation is not enabled. Please enable to use this feature')
            
         if(allowGeoRecall && countLocationAttempts < 5) {
             countLocationAttempts += 1;
             getLocation();
         }
    //   $(".regionalMainPopup,.back-drop").removeClass("hide");  
    // $(".regionalMainPopup .regionalSubmitBtn  ").attr("data-class","regionalMainPopup");
    // $(".regionalMainPopup .redioButton  ").attr("data-class","regionalMainPopup");
   
     }

   function showPosition(position){
      

         var latitude = position.coords.latitude; 
       var longitude = position.coords.longitude; 
        var location = latitude+","+longitude;

      
    const settings = {
    url: 'https://api.positionstack.com/v1/reverse',
    data: {
      access_key: '4b60122760f140445017a6d7d883f4f2',
       query: location,
      limit: 10
    }
    };

$.ajax(settings).done(function (response) {
   var postal_code ='';
  var postalObj = [];
  var data_res = response.data;
  //console.log("postal_response",response);
 
    
 postalObj = data_res.filter(function(data,items){
   //console.log('postalObj',data.postal_code);
   if(data.postal_code){
     postal_code = data.postal_code;
     //return false;
   }
 
});

   
  
//console.log("postal_code",postalObj);
  
if(postalObj.length > 0){
      postal_code = postalObj[0]['postal_code'];
}
   //var postal_code = response.data[0].postal_code;
  
  
  if (postal_code){
   $(".regional_input").val(postal_code);
   
  }
   // $(".regionalMainPopup,.back-drop").removeClass("hide");  
   //  $(".regionalMainPopup .regionalSubmitBtn  ").attr("data-class","regionalMainPopup");
   //  $(".regionalMainPopup .redioButton  ").attr("data-class","regionalMainPopup");
   //  $(".regionalCloseButton").attr("data-value","onloadpop");
  
});
        allowGeoRecall = false;
    }

 
      

});
  
   

